import { Info } from "lucide-react";
import { useState } from "react";

interface InfoPanelProps {
  title: string;
  description: string;
  icon: React.ElementType;
}

export function InfoPanel({ title, description, icon: Icon }: InfoPanelProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        className="ml-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-[var(--muted)] hover:bg-[var(--switch-background)] text-[var(--muted-foreground)] hover:text-[var(--foreground)] transition-all"
        aria-label={title}
      >
        <Info className="w-4 h-4" />
      </button>

      {isOpen && (
        <div
          className="absolute left-0 top-full mt-2 w-80 bg-[var(--card)] border border-[var(--color-steel-border)] rounded-xl p-4 shadow-xl z-50"
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <div className="flex items-start gap-3">
            <Icon className="w-4 h-4 text-[var(--color-steel)] flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-semibold text-[var(--foreground)] mb-1">
                {title}
              </h4>
              <p className="text-xs text-[var(--muted-foreground)] leading-relaxed">
                {description}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}